var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import Link from ".";
var useStyles = makeStyles(function(theme) {
    return {
        root: {
            color: theme.name === "dark" ? theme.palette.secondary.main : theme.palette.primary.main,
            textDecoration: "none",
            "&:hover": {
                color: theme.name === "dark" ? theme.palette.secondary.main : theme.palette.primary.main,
                textDecoration: "underline"
            }
        }
    };
});
export var ContrastLink = function(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, [
        "children",
        "className"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ React.createElement(Link, Object.assign({
        className: classes.root
    }, rest), children);
};
export default ContrastLink;
